__turbopack_context__.v({
  "message": "index-module-scss-module__SL0yjG__message",
  "star": "index-module-scss-module__SL0yjG__star",
});
